import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { loading } from '@/busData';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, _unref(loading)]
  ])
}
}

})